// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Storage from 'vue-ls'
import VueYoutube from 'vue-youtube'
import VueNumeric from 'vue-numeric'
import CKEditor from '@ckeditor/ckeditor5-vue'
import 'viewerjs/dist/viewer.css'
import 'croppr/dist/croppr.css'
import Viewer from 'v-viewer'


import App from './App'
import router from './router'
import store from './store'

Vue.config.productionTip = false

Vue.use(Storage)
Vue.use(VueYoutube)
Vue.use(VueNumeric)
Vue.use(CKEditor)
Vue.use(Viewer)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  template: '<App/>',
  components: {
    App
  },
  router,
  store
})



// WEBPACK FOOTER //
// ./src/main.js